export default __webpack_public_path__ + "static/media/lumen.4bf449ad.svg";